"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.unWatchUserProfile = unWatchUserProfile, exports.handleProfileWatchResponse = handleProfileWatchResponse, exports.linkAndRetrieveDataWithCredential = linkAndRetrieveDataWithCredential, exports.linkWithPopup = linkWithPopup, exports.linkWithRedirect = linkWithRedirect, exports.signInWithPhoneNumber = signInWithPhoneNumber, exports.linkWithCredential = exports.reloadAuth = exports.updateEmail = exports.updateAuth = exports.updateProfile = exports.verifyPasswordResetCode = exports.confirmPasswordReset = exports.resetPassword = exports.createUser = exports.logout = exports.reauthenticate = exports.login = exports.init = exports.handleRedirectResult = exports.createUserProfile = exports.watchUserProfile = void 0;

var _pick2 = _interopRequireDefault(require("lodash/pick")),
    _omit2 = _interopRequireDefault(require("lodash/omit")),
    _forEach2 = _interopRequireDefault(require("lodash/forEach")),
    _constants = require("../constants"),
    _helpers = require("../helpers"),
    _utils = require("../utils"),
    _auth = require("../utils/auth"),
    _populate = require("../utils/populate");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(o, minLen) : void 0;
  }
}

function _iterableToArray(iter) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  (null == len || len > arr.length) && (len = arr.length);

  for (var i = 0, arr2 = Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

function dispatchLoginError(dispatch, authError) {
  var params = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {};
  return dispatch(_objectSpread({
    type: _constants.actionTypes.LOGIN_ERROR
  }, params, {
    authError: authError
  }));
}

function unWatchUserProfile(firebase) {
  var _firebase$_ = firebase._,
      authUid = _firebase$_.authUid,
      _firebase$_$config = _firebase$_.config,
      userProfile = _firebase$_$config.userProfile,
      useFirestoreForProfile = _firebase$_$config.useFirestoreForProfile;
  firebase._.profileWatch && (useFirestoreForProfile && firebase.firestore ? firebase._.profileWatch() : firebase.database().ref().child("".concat(userProfile, "/").concat(authUid)).off("value", firebase._.profileWatch), firebase._.profileWatch = null);
}

function getProfileFromSnap(snap) {
  return snap && snap.val ? snap.val() : snap && snap.data && snap.exists ? snap.data() : null;
}

function handleProfileWatchResponse(dispatch, firebase, userProfileSnap, token) {
  var _firebase$_$config2 = firebase._.config,
      profileParamsToPopulate = _firebase$_$config2.profileParamsToPopulate,
      autoPopulateProfile = _firebase$_$config2.autoPopulateProfile,
      useFirestoreForProfile = _firebase$_$config2.useFirestoreForProfile,
      logErrors = _firebase$_$config2.logErrors,
      profile = getProfileFromSnap(userProfileSnap);
  profileParamsToPopulate && !useFirestoreForProfile && (Array.isArray(profileParamsToPopulate) || (0, _utils.isString)(profileParamsToPopulate)) ? (0, _populate.promisesForPopulate)(firebase, userProfileSnap.key, profile, profileParamsToPopulate).then(function (data) {
    if ((0, _forEach2.default)(data, function (result, path) {
      dispatch({
        type: _constants.actionTypes.SET,
        path: path,
        data: result,
        timestamp: Date.now(),
        requesting: !1,
        requested: !0
      });
    }), !autoPopulateProfile) dispatch({
      type: _constants.actionTypes.SET_PROFILE,
      profile: token ? _objectSpread({}, profile, {
        token: token
      }) : profile
    });else {
      var populates = (0, _populate.getPopulateObjs)(profileParamsToPopulate),
          _profile = userProfileSnap.val();

      dispatch({
        type: _constants.actionTypes.SET_PROFILE,
        profile: (0, _helpers.populate)({
          profile: token ? _objectSpread({}, _profile, {
            token: token
          }) : _profile,
          data: data
        }, "profile", populates)
      });
    }
  }).catch(function (err) {
    logErrors && console.error("RRF: Error retrieving data for profile population. Firebase:", err), dispatch({
      type: _constants.actionTypes.UNAUTHORIZED_ERROR,
      authError: "Error during profile population: ".concat(err.message)
    }), dispatch({
      type: _constants.actionTypes.SET_PROFILE,
      profile: profile
    });
  }) : (useFirestoreForProfile && profileParamsToPopulate && console.warn("Profile population is not yet supported for Firestore"), dispatch({
    type: _constants.actionTypes.SET_PROFILE,
    profile: token ? _objectSpread({}, profile, {
      token: token
    }) : profile
  }));
}

function createProfileWatchErrorHandler(dispatch, firebase) {
  var _firebase$_$config3 = firebase._.config,
      onProfileListenerError = _firebase$_$config3.onProfileListenerError,
      logErrors = _firebase$_$config3.logErrors;
  return function (err) {
    if (logErrors && console.error("Error with profile listener: ".concat(err.message || ""), err), "function" == typeof onProfileListenerError) {
      var factoryResult = onProfileListenerError(err, firebase);
      if ("function" == typeof factoryResult.then) return factoryResult;
    }

    return Promise.reject(err);
  };
}

var watchUserProfile = function watchUserProfile(dispatch, firebase) {
  var _firebase$_2 = firebase._,
      authUid = _firebase$_2.authUid,
      _firebase$_2$config = _firebase$_2.config,
      userProfile = _firebase$_2$config.userProfile,
      useFirestoreForProfile = _firebase$_2$config.useFirestoreForProfile,
      enableClaims = _firebase$_2$config.enableClaims;
  if (unWatchUserProfile(firebase), userProfile) if (useFirestoreForProfile && firebase.firestore) firebase._.profileWatch = firebase.firestore().collection(userProfile).doc(authUid).onSnapshot(function (userProfileSnap) {
    return enableClaims ? firebase.auth().currentUser.getIdTokenResult(!0).then(function (token) {
      return handleProfileWatchResponse(dispatch, firebase, userProfileSnap, token);
    }) : handleProfileWatchResponse(dispatch, firebase, userProfileSnap, null);
  }, createProfileWatchErrorHandler(dispatch, firebase));else if (firebase.database) firebase._.profileWatch = firebase.database().ref().child("".concat(userProfile, "/").concat(authUid)).on("value", function (userProfileSnap) {
    enableClaims ? firebase.auth().currentUser.getIdTokenResult(!0).then(function (token) {
      return handleProfileWatchResponse(dispatch, firebase, userProfileSnap, token);
    }) : handleProfileWatchResponse(dispatch, firebase, userProfileSnap, null);
  }, createProfileWatchErrorHandler(dispatch, firebase));else throw new Error("Real Time Database or Firestore must be included to enable user profile");
};

exports.watchUserProfile = watchUserProfile;

var createUserProfile = function createUserProfile(dispatch, firebase, userData, profile) {
  var config = firebase._.config;
  if (!config.userProfile || !firebase.database && !firebase.firestore) return Promise.resolve(userData);
  if ("function" == typeof config.profileFactory) try {
    profile = config.profileFactory(userData, profile, firebase);
  } catch (err) {
    return console.error("Error occurred within profileFactory function:", err.message || err), Promise.reject(err);
  }
  return config.useFirestoreForProfile ? firebase.firestore().collection(config.userProfile).doc(userData.uid || userData.user.uid).get().then(function (profileSnap) {
    if (!config.updateProfileOnLogin && profileSnap.exists) return profileSnap.data();
    var newProfile = profile;

    if (!newProfile) {
      var userDataObject = userData.uid ? userData.toJSON ? userData.toJSON() : userData : userData.user.toJSON ? userData.user.toJSON() : userData.user;
      newProfile = _objectSpread({}, (0, _omit2.default)(userDataObject, config.keysToRemoveFromAuth), {
        avatarUrl: userDataObject.photoURL
      });
    }

    return Array.isArray(newProfile.providerData) && (newProfile.providerData = newProfile.providerData.map(function (providerDataItem) {
      return (0, _pick2.default)(providerDataItem, config.keysToPreserveFromProviderData);
    })), profileSnap.ref.set(newProfile, {
      merge: !0
    }).then(function () {
      return newProfile;
    });
  }).catch(function (err) {
    return dispatch({
      type: _constants.actionTypes.UNAUTHORIZED_ERROR,
      authError: err
    }), Promise.reject(err);
  }) : firebase.database().ref().child("".concat(config.userProfile, "/").concat(userData.user ? userData.user.uid : userData.uid)).once("value").then(function (profileSnap) {
    return config.updateProfileOnLogin || null === profileSnap.val() ? profileSnap.ref.update(profile).then(function () {
      return profile;
    }) : profileSnap.val();
  }).catch(function (err) {
    return dispatch({
      type: _constants.actionTypes.UNAUTHORIZED_ERROR,
      authError: err
    }), "function" == typeof config.onProfileWriteError && config.onProfileWriteError(err, firebase), Promise.reject(err);
  });
};

exports.createUserProfile = createUserProfile;

var handleAuthStateChange = function handleAuthStateChange(dispatch, firebase, authData) {
  var config = firebase._.config;
  authData ? (firebase._.authUid = authData.uid, config.presence && (0, _auth.setupPresence)(dispatch, firebase), dispatch({
    type: _constants.actionTypes.LOGIN,
    auth: authData,
    preserve: config.preserveOnLogin
  }), watchUserProfile(dispatch, firebase), "function" == typeof config.onAuthStateChanged && config.onAuthStateChanged(authData, firebase, dispatch)) : ("function" == typeof config.onAuthStateChanged && firebase._.config.onAuthStateChanged(authData, firebase, dispatch), dispatch({
    type: _constants.actionTypes.AUTH_EMPTY_CHANGE,
    preserve: config.preserveOnEmptyAuthChange
  }), unWatchUserProfile(firebase));
},
    handleRedirectResult = function handleRedirectResult(dispatch, firebase, authData) {
  if ("function" == typeof firebase._.config.onRedirectResult && firebase._.config.onRedirectResult(authData, firebase, dispatch), authData && authData.user) {
    var user = authData.user;
    return firebase._.authUid = user.uid, watchUserProfile(dispatch, firebase), dispatch({
      type: _constants.actionTypes.LOGIN,
      auth: user,
      preserve: firebase._.config.preserveOnLogin
    }), createUserProfile(dispatch, firebase, user, {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    });
  }
};

exports.handleRedirectResult = handleRedirectResult;

var init = function init(dispatch, firebase) {
  firebase.auth && (dispatch({
    type: _constants.actionTypes.AUTHENTICATION_INIT_STARTED
  }), firebase.auth().onAuthStateChanged(function (authData) {
    return handleAuthStateChange(dispatch, firebase, authData);
  }), firebase._.config.enableRedirectHandling && "function" == typeof firebase.auth().getRedirectResult && "undefined" != typeof window && window.location && window.location.protocol && -1 !== window.location.protocol.indexOf("http") && firebase.auth().getRedirectResult().then(function (authData) {
    return handleRedirectResult(dispatch, firebase, authData);
  }).catch(function (error) {
    return dispatchLoginError(dispatch, error), Promise.reject(error);
  }), firebase.auth().currentUser, dispatch({
    type: _constants.actionTypes.AUTHENTICATION_INIT_FINISHED
  }));
};

exports.init = init;

var login = function login(dispatch, firebase, credentials) {
  var _firebase$auth;

  firebase._.config.resetBeforeLogin && dispatchLoginError(dispatch, null);

  var _getLoginMethodAndPar = (0, _auth.getLoginMethodAndParams)(firebase, credentials),
      method = _getLoginMethodAndPar.method,
      params = _getLoginMethodAndPar.params;

  return (_firebase$auth = firebase.auth())[method].apply(_firebase$auth, _toConsumableArray(params)).then(function (userData) {
    if (!userData) return Promise.resolve(null);
    if (["signInWithEmailAndPassword", "signInAndRetrieveDataWithEmailAndPassword"].includes(method)) return {
      user: userData
    };
    if (["signInWithCustomToken", "signInAndRetrieveDataWithCustomToken"].includes(method)) return firebase._.config.updateProfileOnLogin ? createUserProfile(dispatch, firebase, userData, credentials.profile) : {
      user: userData
    };
    if ("signInWithPhoneNumber" === method) return _objectSpread({}, userData, {
      confirm: function confirm(code) {
        return userData.confirm(code).then(function (_ref) {
          var user = _ref.user,
              additionalUserInfo = _ref.additionalUserInfo;
          return createUserProfile(dispatch, firebase, user, {
            phoneNumber: user.providerData[0].phoneNumber,
            providerData: user.providerData
          }).then(function (profile) {
            return {
              profile: profile,
              user: user,
              additionalUserInfo: additionalUserInfo
            };
          });
        });
      }
    });
    var user = userData.user || userData;
    return createUserProfile(dispatch, firebase, user, credentials.profile || {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    }).then(function (profile) {
      return _objectSpread({
        profile: profile
      }, userData);
    });
  }).catch(function (err) {
    return dispatchLoginError(dispatch, err), Promise.reject(err);
  });
};

exports.login = login;

var reauthenticate = function reauthenticate(dispatch, firebase, credentials) {
  var _firebase$auth$curren,
      _getReauthenticateMet = (0, _auth.getReauthenticateMethodAndParams)(firebase, credentials),
      method = _getReauthenticateMet.method,
      params = _getReauthenticateMet.params;

  return (_firebase$auth$curren = firebase.auth().currentUser)[method].apply(_firebase$auth$curren, _toConsumableArray(params)).then(function (userData) {
    if (!userData) return Promise.resolve(null);
    if ("reauthenticateWithPhoneNumber" === method) return _objectSpread({}, userData, {
      confirm: function confirm(code) {
        return userData.confirm(code).then(function (_ref2) {
          var user = _ref2.user,
              additionalUserInfo = _ref2.additionalUserInfo;
          return createUserProfile(dispatch, firebase, user, {
            phoneNumber: user.providerData[0].phoneNumber,
            providerData: user.providerData
          }).then(function (profile) {
            return {
              profile: profile,
              user: user,
              additionalUserInfo: additionalUserInfo
            };
          });
        });
      }
    });
    var user = userData.user || userData;
    return createUserProfile(dispatch, firebase, user, credentials.profile || {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    }).then(function (profile) {
      return _objectSpread({
        profile: profile
      }, userData);
    });
  }).catch(function (err) {
    return dispatchLoginError(dispatch, err, {
      reauthenticate: !0
    }), Promise.reject(err);
  });
};

exports.reauthenticate = reauthenticate;

var logout = function logout(dispatch, firebase) {
  return unWatchUserProfile(firebase), firebase.auth().signOut().then(function () {
    var action = {
      type: _constants.actionTypes.LOGOUT
    };
    return firebase._.config.preserveOnLogout && (action.preserve = firebase._.config.preserveOnLogout), dispatch(action), firebase._.authUid = null, firebase;
  });
};

exports.logout = logout;

var createUser = function createUser(dispatch, firebase, _ref3, profile) {
  var email = _ref3.email,
      password = _ref3.password;

  if (dispatchLoginError(dispatch, null), !email || !password) {
    var error = new Error("Email and Password are required to create user");
    return dispatchLoginError(dispatch, error), Promise.reject(error);
  }

  return firebase.auth().createUserWithEmailAndPassword(email, password).then(function (userData) {
    return createUserProfile(dispatch, firebase, userData, profile || {
      email: email
    });
  }).catch(function (err) {
    return dispatchLoginError(dispatch, err), Promise.reject(err);
  });
};

exports.createUser = createUser;

var resetPassword = function resetPassword(dispatch, firebase, email) {
  return dispatchLoginError(dispatch, null), firebase.auth().sendPasswordResetEmail(email).catch(function (err) {
    if (err) {
      switch (err.code) {
        case "auth/user-not-found":
          dispatchLoginError(dispatch, new Error("The specified user account does not exist."));
          break;

        default:
          dispatchLoginError(dispatch, err);
      }

      return Promise.reject(err);
    }
  });
};

exports.resetPassword = resetPassword;

var confirmPasswordReset = function confirmPasswordReset(dispatch, firebase, code, password) {
  return dispatchLoginError(dispatch, null), firebase.auth().confirmPasswordReset(code, password).catch(function (err) {
    if (err) {
      switch (err.code) {
        case "auth/expired-action-code":
          dispatchLoginError(dispatch, new Error("The action code has expired."));
          break;

        case "auth/invalid-action-code":
          dispatchLoginError(dispatch, new Error("The action code is invalid."));
          break;

        case "auth/user-disabled":
          dispatchLoginError(dispatch, new Error("The user is disabled."));
          break;

        case "auth/user-not-found":
          dispatchLoginError(dispatch, new Error("The user is not found."));
          break;

        case "auth/weak-password":
          dispatchLoginError(dispatch, new Error("The password is not strong enough."));
          break;

        default:
          dispatchLoginError(dispatch, err);
      }

      return Promise.reject(err);
    }
  });
};

exports.confirmPasswordReset = confirmPasswordReset;

var verifyPasswordResetCode = function verifyPasswordResetCode(dispatch, firebase, code) {
  return dispatchLoginError(dispatch, null), firebase.auth().verifyPasswordResetCode(code).catch(function (err) {
    return err && dispatchLoginError(dispatch, err), Promise.reject(err);
  });
};

exports.verifyPasswordResetCode = verifyPasswordResetCode;

var updateProfile = function updateProfile(dispatch, firebase, profileUpdate, options) {
  var config = firebase._.config;
  dispatch({
    type: _constants.actionTypes.PROFILE_UPDATE_START,
    payload: profileUpdate
  });
  var updatePromise = config.useFirestoreForProfile ? _auth.updateProfileOnFirestore : _auth.updateProfileOnRTDB;
  return updatePromise(firebase, profileUpdate, options).then(function (snap) {
    return dispatch({
      type: _constants.actionTypes.PROFILE_UPDATE_SUCCESS,
      payload: config.useFirestoreForProfile ? snap.data() : snap.val()
    }), snap;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.PROFILE_UPDATE_ERROR,
      error: error
    }), Promise.reject(error);
  });
};

exports.updateProfile = updateProfile;

var updateAuth = function updateAuth(dispatch, firebase, authUpdate, updateInProfile) {
  if (dispatch({
    type: _constants.actionTypes.AUTH_UPDATE_START,
    payload: authUpdate
  }), !firebase.auth().currentUser) {
    var error = new Error("User must be logged in to update auth.");
    return dispatch({
      type: _constants.actionTypes.AUTH_UPDATE_ERROR,
      payload: error
    }), Promise.reject(error);
  }

  return firebase.auth().currentUser.updateProfile(authUpdate).then(function (payload) {
    return dispatch({
      type: _constants.actionTypes.AUTH_UPDATE_SUCCESS,
      auth: firebase.auth().currentUser
    }), updateInProfile ? updateProfile(dispatch, firebase, authUpdate) : payload;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.AUTH_UPDATE_ERROR,
      error: error
    }), Promise.reject(error);
  });
};

exports.updateAuth = updateAuth;

var updateEmail = function updateEmail(dispatch, firebase, newEmail, updateInProfile) {
  if (dispatch({
    type: _constants.actionTypes.EMAIL_UPDATE_START,
    payload: newEmail
  }), !firebase.auth().currentUser) {
    var error = new Error("User must be logged in to update email.");
    return dispatch({
      type: _constants.actionTypes.EMAIL_UPDATE_ERROR,
      error: error
    }), Promise.reject(error);
  }

  return firebase.auth().currentUser.updateEmail(newEmail).then(function (payload) {
    return dispatch({
      type: _constants.actionTypes.EMAIL_UPDATE_SUCCESS,
      payload: newEmail
    }), updateInProfile ? updateProfile(dispatch, firebase, {
      email: newEmail
    }) : payload;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.EMAIL_UPDATE_ERROR,
      error: error
    }), Promise.reject(error);
  });
};

exports.updateEmail = updateEmail;

var reloadAuth = function reloadAuth(dispatch, firebase) {
  if (dispatch({
    type: _constants.actionTypes.AUTH_RELOAD_START
  }), !firebase.auth().currentUser) {
    var error = new Error("User must be logged in to reload auth.");
    return dispatch({
      type: _constants.actionTypes.AUTH_RELOAD_ERROR,
      error: error
    }), Promise.reject(error);
  }

  return firebase.auth().currentUser.reload().then(function () {
    var auth = firebase.auth().currentUser;
    return dispatch({
      type: _constants.actionTypes.AUTH_RELOAD_SUCCESS,
      payload: auth
    }), auth;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.AUTH_RELOAD_ERROR,
      error: error
    }), Promise.reject(error);
  });
};

exports.reloadAuth = reloadAuth;

var linkWithCredential = function linkWithCredential(dispatch, firebase, credential) {
  if (dispatch({
    type: _constants.actionTypes.AUTH_LINK_START
  }), !firebase.auth().currentUser) {
    var error = new Error("User must be logged in to link with credential.");
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_ERROR,
      error: error
    }), Promise.reject(error);
  }

  return firebase.auth().currentUser.linkWithCredential(credential).then(function (auth) {
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_SUCCESS,
      payload: auth
    }), auth;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_ERROR,
      error: error
    }), Promise.reject(error);
  });
};

exports.linkWithCredential = linkWithCredential;

function linkWithAuthDispatch(promiseFunc, args, dispatch, firebase) {
  if (dispatch({
    type: _constants.actionTypes.AUTH_LINK_START
  }), !firebase.auth().currentUser) {
    var error = new Error("User must be logged in to link with credential.");
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_ERROR,
      error: error
    }), Promise.reject(error);
  }

  return promiseFunc.apply(void 0, _toConsumableArray(args)).then(function (auth) {
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_SUCCESS,
      payload: auth
    }), auth;
  }).catch(function (error) {
    return dispatch({
      type: _constants.actionTypes.AUTH_LINK_ERROR,
      error: error
    }), Promise.reject(error);
  });
}

function linkAndRetrieveDataWithCredential(dispatch, firebase, credential) {
  return linkWithAuthDispatch(firebase.auth().currentUser.linkAndRetrieveDataWithCredential, [credential], dispatch, firebase);
}

function linkWithPopup(dispatch, firebase, credential) {
  return linkWithAuthDispatch(firebase.auth().currentUser.linkWithPopup, [credential], dispatch, firebase);
}

function linkWithRedirect(dispatch, firebase, provider) {
  return linkWithAuthDispatch(firebase.auth().currentUser.linkWithRedirect, [provider], dispatch, firebase);
}

function signInWithPhoneNumber(firebase, dispatch, phoneNumber, applicationVerifier) {
  var options = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : {};
  return login(dispatch, firebase, _objectSpread({
    phoneNumber: phoneNumber,
    applicationVerifier: applicationVerifier
  }, options));
}